<template>
    <div>
        <div class="share-cgpp-title">确定八字名称或分组</div>
        <div class="share-cgpp-item">
            <label class="collate-form-label cf-label-two">姓 名</label>
            <input class="collate-form-input" type="text" maxlength="15" placeholder="输入称呼" @blur="blurNameInput" v-model="formData.f_name" autofocus>
        </div>
        <div class="share-cgpp-item" @click="chooseGroup">
            <label class="collate-form-label cf-label-two">分 组</label>
            <div class="share-cgpp-choose">
                <span v-if="formData.group" class="share-cgpp-text-have">{{formData.group.slice(0, 10)}}</span>
                <span v-else class="share-cgpp-text">选择分组</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>
        <div class="share-cgpp-button" @click="confirmChange">确定</div>
    </div>
</template>

<script>
export default {
    name: 'GroupChangeSave',
    props: {
        formData: {
            type: Object,
            default() { return {} }
        },
        chooseFunc: {
            type: Function,
            default() { return null }
        },
        confirmFunc: {
            type: Function,
            default() { return null }
        }
    },
    methods: {
        blurNameInput() {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 20);
        },
        chooseGroup() {
            if(this.chooseFunc && typeof(this.chooseFunc) == 'function') {
                this.chooseFunc();
            }
        },
        confirmChange() {
            if(this.confirmFunc && typeof(this.confirmFunc) == 'function') {
                this.confirmFunc();
            }
        }
    }
}
</script>